import { useEffect } from "react";
import {
  acquireBackgroundInteractionLock,
  acquireBodyScrollLock,
  releaseBackgroundInteractionLock,
  releaseBodyScrollLock
} from "./backgroundInteractionLock";

export const useBodyScrollLock = (locked: boolean) => {
  useEffect(() => {
    if (!locked) return;

    acquireBodyScrollLock();

    return () => {
      releaseBodyScrollLock();
    };
  }, [locked]);
};

const useRemoveModalBackgroundScroll = (
  showModal: boolean,
  lockBackgroundInteraction = true
) => {
  const shouldLock = showModal && lockBackgroundInteraction;

  useBodyScrollLock(shouldLock);

  useEffect(() => {
    if (!shouldLock) return;

    acquireBackgroundInteractionLock();

    return () => {
      releaseBackgroundInteractionLock();
    };
  }, [shouldLock]);
};

export default useRemoveModalBackgroundScroll;
